import { createContext, type ReactNode, useContext, useState } from "react";

type BottomSheetContextType = {
    bottomSheetIsOpen: boolean;
    openBottomSheet: (open: boolean) => void;
};

export const BottomSheetContext = createContext<BottomSheetContextType>({
    bottomSheetIsOpen: false,
    openBottomSheet: () => null,
});

export function BottomSheetProvider({ children }: { children: ReactNode }) {
    const [bottomSheetIsOpen, openBottomSheet] = useState(false);

    return (
        <BottomSheetContext.Provider value={{ bottomSheetIsOpen, openBottomSheet }}>
            {children}
        </BottomSheetContext.Provider>
    );
}

export function useBottomSheetContext() {
    const context = useContext(BottomSheetContext);

    if (!context) {
        throw new Error(
            "useBottomSheetContext must be used within a BottomSheetProvider",
        );
    }

    return context;
}
